// extracted by mini-css-extract-plugin
module.exports = {"ForumSearch__headline":"pt_a bhc_rh bhc_tu","ForumSearch__img":"pt_b","ForumSearch__searchAdsAndShoppingAds":"pt_c","ForumSearch__results--empty":"pt_e"};